"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getWebshellclientLocale = _interopRequireDefault(require("../../../../utils/get-webshellclient-locale"));
var _makeQueryKey = _interopRequireDefault(require("../../../../utils/make-query-key"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getCartQueryKey = function getCartQueryKey() {
  var _getWebShellClientLoc = (0, _getWebshellclientLocale["default"])(),
    country = _getWebShellClientLoc.country;
  return (0, _makeQueryKey["default"])(['buy/carts/v2', {
    country: country
  }]);
};
var _default = exports["default"] = getCartQueryKey;